import { showToast } from './toast';

// Ticking timecode in the camcorder overlay — starts just before midnight and
// rolls into the small hours, reinforcing the "tonight's rental" framing.
function startTimecode(): void {
  const el = document.getElementById('timecode');
  if (!el) return;
  let h = 23;
  let m = 58;
  let s = 42;
  setInterval(() => {
    s++;
    if (s >= 60) {
      s = 0;
      m++;
    }
    if (m >= 60) {
      m = 0;
      h++;
    }
    if (h >= 24) h = 0;
    const period = h >= 12 ? 'PM' : 'AM';
    const h12 = ((h + 11) % 12) + 1;
    el.innerHTML = `SP&nbsp;&nbsp;${String(h12).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')} ${period}`;
  }, 1000);
}

// Konami code → VHS tracking glitch overlay + toast. Listener is installed
// before main.ts wires its keydown handler so we can stopImmediatePropagation
// on B/A and prevent them from leaking onto the board.
function startKonami(): void {
  const SEQ = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
  ] as const;
  let idx = 0;
  document.addEventListener('keydown', (e) => {
    const k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
    if (k === SEQ[idx]) {
      idx++;
      if (k === 'b' || k === 'a') e.stopImmediatePropagation();
      if (idx === SEQ.length) {
        idx = 0;
        document.body.classList.add('tracking-glitch');
        showToast('TRACKING ADJUSTED');
        setTimeout(() => document.body.classList.remove('tracking-glitch'), 1600);
      }
    } else {
      idx = k === SEQ[0] ? 1 : 0;
    }
  });
}

function logBanner(): void {
  // eslint-disable-next-line no-console
  console.log(
    '%c\n' +
      '  ┌─────────────────────────┐\n' +
      '  │ ░░░ TAPE TRAP ░░░       │\n' +
      '  │ ╔═════╗     ╔═════╗     │\n' +
      '  │ ║ ○ ○ ║ ═══ ║ ○ ○ ║     │\n' +
      '  │ ╚═════╝     ╚═════╝     │\n' +
      '  └─────────────────────────┘\n' +
      '  inspect: window.state\n' +
      '  be kind. rewind. ↑↑↓↓←→←→BA\n',
    'font-family: monospace; color: #ff2d92; font-size: 12px; line-height: 1.4;',
  );
}

// Call this first thing in main.ts. The Konami listener must beat the main
// game keydown listener so B/A presses don't make it onto the board.
export function installEasterEggs(): void {
  startTimecode();
  startKonami();
  logBanner();
}
